<template>
    <div>
        <div class="content-caption dashed">
            <span><span class="color-laber"></span>离职人员信息</span>
        </div>
        <div class="form-row">
            <div class="form-label">
                <label class="">所属公司：</label>
            </div>
            <div class="form-value width-2x">
                <el-input disabled v-model="staffInfo.comName"></el-input>
            </div>
        </div>
        <div class="form-row">
            <div class="form-label">
                <label class="">员工名称：</label>
            </div>
            <div class="form-value width-2x">
                <el-input disabled v-model="staffInfo.name"></el-input>
            </div>
        </div>
        <div class="form-row">
            <div class="form-label">
                <label class="">联系电话：</label>
            </div>
            <div class="form-value width-2x">
                <el-input disabled v-model="staffInfo.phoneNo"></el-input>
            </div>
        </div>

        <div class="form-row spacing" style="height: 88px">
            <div class="form-label">
                <label class="">申请描述：</label>
            </div>
            <div class="form-value width-2x">
                <el-input style="height: 78px" type="textarea" v-model="applyDesc"></el-input>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    export default {
        name: 'swb-staff-resign-from-save',
        avlActions: '',
        avlScopes: 'retailer',
        notAsResc: true,
        authen: false,
        desc: '人员离职信息',
        props: ["staffInfo"],
        data: function () {
            return {
                applyDesc: null
            }
        },
        created: function () {
            //
        },
        methods: {
            getDlgResult() {
                return this.applyDesc || null;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/staffBiz/StaffResignFromSave.vue